<p class="debugMessage"><small>account-manage-users:</small></p>

<ejs-accordion style="margin-top: 1em; border-radius: var(--default-border-radius);">
	<e-accordionitems>
		<e-accordionitem expanded='true'>
			<ng-template #header>
				<div><u>Registered Users</u></div>
			</ng-template>
			<ng-template #content>
				<div><ng-container *ngTemplateOutlet="AccountUsers"></ng-container></div>
			</ng-template>
		</e-accordionitem>
		<e-accordionitem>
			<ng-template #header>
				<div><u>Invited Users</u></div>
			</ng-template>
			<ng-template #content>
				<div><ng-container *ngTemplateOutlet="InvitedUsers"></ng-container></div>
			</ng-template>
		</e-accordionitem>
		<e-accordionitem *ngIf="deletedAccountUsers.length > 0">
			<ng-template #header>
				<div><u>Removed Users</u></div>
			</ng-template>
			<ng-template #content>
				<div><ng-container *ngTemplateOutlet="deletedUsers"></ng-container></div>
			</ng-template>
		</e-accordionitem>
	</e-accordionitems>
</ejs-accordion>

<ng-template #AccountUsers>
	<nav class="navbar navbar-expand-lg alignRow" style="height: var(--navBar-Height);">
		<span style="background-color: whitesmoke; padding: 0.2em; border-radius: var(--default-border-radius);">
			<mat-slide-toggle color="primary" (change)="showWebsiteAdmins($event)" [checked]="showingWebsiteAdmins">
				<small>Show System Administrators</small>
			</mat-slide-toggle>
		</span>
		<span class="me-auto"></span>
		<span class="app-icon app-icon--refresh" (click)="refreshAccountUsers()"><mat-icon /></span>
		<app-filter-box *ngIf="filteredAccountUsers && filteredAccountUsers.filteredData.length > 0"
			(search)="applyFilter($event)" PlaceHolder="Filter Users"></app-filter-box>
		<span *ngIf="thisUser && thisUser.AdminSite" class="app-icon app-icon--add siteAdmin-only-outline"
			[matTooltip]="'Admin Only'" (click)="addUser()"><mat-icon /></span>
	</nav>

	<div class="registeredUserGrid gridRow gridRowH" style="font-weight: bold;">
		<div class="gridUser-User">User</div>
		<div class="gridUser-Email">Email</div>
		<div class="gridUser-AccountRole">Role</div>
		<div class="gridUser-Groups">Group Membership</div>
	</div>

	<span *ngIf="filteredAccountUsers">
		<div class="registeredUserGrid gridRow alignRow" *ngFor="let user of filteredAccountUsers.filteredData"
			[ngClass]="{'disabled-user': user.AccountUserDisabled}"
			[title]="user.AccountUserDisabled ? user.Name + ' is disabled' : ''">
			<div class="gridUser-User-h">User:</div>
			<span class="gridUser-User">
				<span>{{user.Name}}</span>
				<small class="admin" *ngIf="user.Admin && !user.AdminSite">Admin</small>
				<small class="admin" *ngIf="user.AdminSite" style="background-color: gold;">Website Admin</small>
				<small class="admin" *ngIf="user.UserID == selectedAccount.OwnerID"
					style="background-color: limegreen;">Owner</small>
			</span>

			<div class="gridUser-AccountRole-h">Role:</div>
			<span *ngIf="!editingUserRole || (user.UserID != editingUserRole.UserID)"
				class="gridUser-AccountRole alignRow" style="width: 100%;">
				<span style="width: 100%;">{{getSafeAccountRoleLabel(user.AccountRole)}}</span>
				<span class="alignRow gridUser-Hover" [ngClass]="{'siteAdmin-only-outline' : thisUser.AdminSite}"
					*ngIf="!user.AccountUserDisabled && thisUser.AdminSite && user.UserID != thisUser.UserID && !user.AdminSite && (selectedAccount.OwnerID != user.UserID)">
					<!-- <span class="me-auto"></span> -->
					<mat-icon (click)="editAccountUserRole(user)">edit</mat-icon>
				</span>
			</span>
			<div *ngIf="editingUserRole && (user.UserID == editingUserRole.UserID)"
				class="gridUser-AccountRole alignRow" style="width: 100%;">
				<ejs-dropdownlist id="dropdown" #dropdown [dataSource]='accountRoleArray' [value]="user.AccountRole"
					[fields]="accountRoleFields" (change)="patchUserRole($event, user)">
					<ng-template #itemTemplate let-data>
						<div>
							<span>{{ data.Description }}</span>
						</div>
					</ng-template>
				</ejs-dropdownlist>
				<span class="alignRow gridUser-Hover siteAdmin-only-outline"
					*ngIf="!user.AccountUserDisabled && thisUser.AdminSite && user.UserID != thisUser.UserID">
					<!-- <span class="me-auto"></span> -->
					<mat-icon (click)="editAccountUserRole()">check</mat-icon>
				</span>
			</div>

			<div class="gridUser-Email-h" mat-header-cell>Email:</div>
			<span class="gridUser-Email"><span>{{user.Email}}</span></span>

			<div class="gridUser-Groups-h">Groups:</div>
			<span class="gridUser-Groups alignRow"><span>{{user.Groups}}</span>&nbsp;</span>
			<div class="gridUser-Hover-h"></div>

			<span class="gridUser-Hover alignRow">
				<span *ngIf="selectedAccount.Admin || thisUser.AdminSite" class="alignRow">
					<span *ngIf="!user.AccountUserDisabled"><ng-container
							*ngTemplateOutlet="buttonEmails"></ng-container></span>
					<span *ngIf="!user.AccountUserDisabled"><ng-container
							*ngTemplateOutlet="buttonAdmin"></ng-container></span>
					<span *ngIf="!user.Admin && user.UserID != selectedAccount.OwnerID">
						<ng-container *ngTemplateOutlet="buttonDisable"></ng-container>
					</span>
					<span *ngIf="!user.Admin && user.UserID != selectedAccount.OwnerID">
						<ng-container *ngTemplateOutlet="buttonRemove"></ng-container>
					</span>
				</span>
			</span>

			<span class="gridUser-Menu alignRow">
				<span *ngIf="selectedAccount.Admin || thisUser.AdminSite" class="app-icon app-icon--more alignRow"
					mat-icon-button [matMenuTriggerFor]="userMenu"><mat-icon /></span>
			</span>

			<mat-menu #userMenu [overlapTrigger]="false" yPosition="above" xPosition="after">
				<button mat-menu-item *ngIf="!user.AccountUserDisabled">
					<ng-container *ngTemplateOutlet="buttonEmails; context: { menu: true }"></ng-container></button>

				<button mat-menu-item *ngIf="!user.AccountUserDisabled">
					<ng-container *ngTemplateOutlet="buttonAdmin; context: { menu: true }"></ng-container></button>

				<button mat-menu-item *ngIf="!user.Admin && user.UserID != selectedAccount.OwnerID">
					<ng-container *ngTemplateOutlet="buttonDisable; context: { menu: true }"></ng-container></button>

				<button mat-menu-item *ngIf="!user.Admin && user.UserID != selectedAccount.OwnerID">
					<ng-container *ngTemplateOutlet="buttonRemove; context: { menu: true }"></ng-container></button>

			</mat-menu>

			<ng-template #buttonEmails let-menu="menu">
				<ng-container *ngIf="selectedAccount.Admin && !user.AccountUserDisabled">
					<span class="app-icon " [ngClass]="user.Emails ? 'app-icon--unsubscribe' : 'app-icon--email'"
						(click)="changeSendEmail(!user.Emails, user.UserID)">
						<mat-icon [ngStyle]="{ color: 'black' }"
							[title]="user.Emails ? 'Unsubscribe ' + user.Name : 'Subscribe ' + user.Name" />
						<span *ngIf="menu">{{ user.Emails ? 'Unsubscribe' : 'Subscribe' }}</span>
					</span>
				</ng-container>
			</ng-template>

			<ng-template #buttonAdmin let-menu="menu">
				<span class="app-icon " [ngClass]="user.Admin ? 'app-icon--verified-user' : 'app-icon--shield'"
					*ngIf="selectedAccount.Admin && !user.AccountUserDisabled && user.UserID != selectedAccount.OwnerID"
					(click)="selectedAccount.Admin && !user.AccountUserDisabled && changeAdmin(!user.Admin, user.UserID)">
					<mat-icon [ngStyle]="{
						color: (!selectedAccount.Admin || user.AccountUserDisabled)
								? 'gray'
								: user.Admin
								? 'gold'
								: 'black'
					}" [title]="selectedAccount.Admin && !user.AccountUserDisabled? (
							user.Admin
							? 'Demote ' + user.Name + ' To User'
							: 'Promote ' + user.Name + ' To Admin'
						): ''" />
					<span *ngIf="menu && selectedAccount.Admin && !user.AccountUserDisabled">
						{{ user.Admin ? 'Demote' : 'Promote' }}
					</span>
				</span>
			</ng-template>

			<ng-template #buttonDisable let-menu="menu">
				<ng-container *ngIf="(selectedAccount.Admin || thisUser.AdminSite) && !user.Admin as canToggle">
					<span class="app-icon"
						[ngClass]="user.AccountUserDisabled ? 'app-icon--enable-user' : 'app-icon--disable-user'"
						(click)="canToggle ? changeUserEnabled(user.AccountUserDisabled, user.UserID) : null">
						<mat-icon [title]="canToggle ? (
							user.AccountUserDisabled
							? 'Enable ' + user.Name
							: 'Disable ' + user.Name
						) : ''" [ngStyle]="{ color: canToggle ? 'black' : 'gray' }" />
						<span *ngIf="menu && canToggle">
							{{ user.AccountUserDisabled ? 'Enable' : 'Disable' }}
						</span>
					</span>
				</ng-container>
			</ng-template>

			<ng-template #buttonRemove let-menu="menu">
				<ng-container *ngIf="!user.Admin">
					<span class="app-icon "
						[ngClass]="user.UserID === thisUser.UserID ? 'app-icon--exit-app' : 'app-icon--person-remove'"
						(click)="(selectedAccount.Admin || user.UserID === thisUser.UserID) ? deleteAccountUser(user.UserID) : null">
						<mat-icon [ngStyle]="{
						color: (selectedAccount.Admin || thisUser.AdminSite)
							? 'var(--color-red)'
							: (user.UserID === thisUser.UserID ? 'red' : 'gray')
					}" [title]=" selectedAccount.Admin ? 'Remove ' + user.Name : (user.UserID === thisUser.UserID ? 'Leave Account' : '')
					" />
						<span *ngIf="menu">
							{{ selectedAccount.Admin ? 'Remove' : (user.UserID === thisUser.UserID ? 'Leave Account' :
							'')}}
						</span>
					</span>
				</ng-container>
			</ng-template>
		</div>
	</span>
</ng-template>

<ng-template #InvitedUsers>
	<div *ngIf="selectedAccount.Admin">
		<!-- <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
			[(ngModel)]="choiceSelected" (ngModelChange)="filterInvites()">
			<mat-radio-button class="example-radio-button" color="primary" value="Canceled">Canceled</mat-radio-button>
			<mat-radio-button class="example-radio-button" color="primary" value="Accepted">Accepted</mat-radio-button>
			<mat-radio-button class="example-radio-button" color="primary" value="Pending">Pending</mat-radio-button>
		</mat-radio-group> -->

		<ejs-tab #tabs id="element" [selectedItem]="choiceSelected" (selecting)="tabChange($event)">
			<e-tabitems>
				<e-tabitem>
					<ng-template #headerText>
						<mat-icon>people</mat-icon>&nbsp;Pending
					</ng-template>
					<ng-template #content>
					</ng-template>
				</e-tabitem>
				<e-tabitem>
					<ng-template #headerText>
						<mat-icon>people</mat-icon>&nbsp;Accepted
					</ng-template>
					<ng-template #content>
					</ng-template>
				</e-tabitem>
				<e-tabitem>
					<ng-template #headerText>
						<mat-icon>people</mat-icon>&nbsp;Canceled
					</ng-template>
					<ng-template #content>
					</ng-template>
				</e-tabitem>
			</e-tabitems>
		</ejs-tab>
	</div>
	<div class="invitedregisteredUserGrid gridRow gridRowH" style="font-weight: bold;">
		<!-- <div class="gridName">Name:</div> -->
		<div class="gridInvitedUser-Email">Email:</div>
		<div class="gridInvitedUser-Sender">Sender:</div>
		<div class="gridInvitedUser-Sent">Sent:</div>
		<div class="gridInvitedUser-Expires" *ngIf="choiceSelected != 'Accepted'">Expires:</div>
		<div class="gridInvitedUser-Accepted" *ngIf="choiceSelected == 'Accepted'">Accepted:</div>
	</div>
	<div class="invitedregisteredUserGrid gridRow" *ngFor="let invite of filteredinvites">
		<!-- <div class="gridName-h">Name:</div> -->
		<div class="gridInvitedUser-Email-h">Email:</div>
		<div class="gridInvitedUser-Sender-h">Sender:</div>
		<div class="gridInvitedUser-Sent-h">Sent:</div>
		<div class="gridInvitedUser-Expires-h" *ngIf="choiceSelected != 'Accepted'">Expires:</div>
		<div class="gridInvitedUser-Accepted-h" *ngIf="choiceSelected == 'Accepted'">Accepted:</div>

		<!-- <div class="gridName">{{invite?.InviteName}}</div> -->
		<div class="gridInvitedUser-Email">{{invite?.InviteEmail}}<small class="admin" matTooltip="Admin"
				*ngIf="invite.InviteAsAdmin">*</small>
		</div>
		<div class="gridInvitedUser-Sender">{{invite?.Name}}</div>
		<div class="gridInvitedUser-Sent">{{convertEpoch(invite.InviteDateTime)}}</div>
		<div class="gridInvitedUser-Expires" *ngIf="choiceSelected != 'Accepted'">{{convertEpoch(invite.InviteExpires)}}
		</div>
		<div class="gridInvitedUser-Accepted" *ngIf="choiceSelected == 'Accepted'">{{convertEpoch(invite.AcceptedDate)}}
		</div>

		<span class="gridInvitedUser-Hover alignRow" *ngIf="choiceSelected != 'Accepted'">
			<span class="gridInvitedUser-Resend">
				<ng-container *ngIf="selectedAccount.Admin; else disabledIcon" [ngTemplateOutlet]="resendInviteTemplate"
					[ngTemplateOutletContext]="{ icon: 'outgoing_mail',text: 'Re Send',inviteGUID: invite?.InviteGUID }">
				</ng-container>
			</span>
			<span class="gridInvitedUser-Cancel" *ngIf="!showingCancelled">
				<ng-container *ngIf="selectedAccount.Admin; else disabledIcon" [ngTemplateOutlet]="cancelInviteTemplate"
					[ngTemplateOutletContext]="{ icon: 'unsubscribe',text: 'Cancel',inviteGUID: invite?.InviteGUID }">
				</ng-container>
			</span>
		</span>

		<span class="gridInvitedUser-Menu alignRow" *ngIf="choiceSelected != 'Accepted'">
			<span *ngIf="selectedAccount.Admin || thisUser.AdminSite" class="app-icon app--icon-more alignRow"
				mat-icon-button [matMenuTriggerFor]="userMenu"><mat-icon /></span>
		</span>

		<mat-menu #userMenu [overlapTrigger]="false" yPosition="above" xPosition="after">
			<button mat-menu-item>
				<ng-container *ngIf="selectedAccount.Admin; else disabledIcon" [ngTemplateOutlet]="resendInviteTemplate"
					[ngTemplateOutletContext]="{ icon: 'outgoing_mail',text: 'Re Send',inviteGUID: invite?.InviteGUID }">
				</ng-container></button>

			<button mat-menu-item *ngIf="!showingCancelled">
				<ng-container *ngIf="selectedAccount.Admin; else disabledIcon" [ngTemplateOutlet]="cancelInviteTemplate"
					[ngTemplateOutletContext]="{ icon: 'unsubscribe',text: 'Cancel',inviteGUID: invite?.InviteGUID }">
				</ng-container></button>
		</mat-menu>

	</div>

	<button mat-flat-button style="margin-top: var(--default-margin);" color="primary" type="submit"
		(click)="sendInvite()" *ngIf="this.selectedAccount.Admin">
		<mat-icon>mail</mat-icon>Invite User
	</button>
</ng-template>

<ng-template #resendInviteTemplate let-icon="icon" let-text="text" let-inviteGUID="inviteGUID">
	<span class="alignRow" (click)="resendInvite(inviteGUID)">
		<mat-icon style="margin-right: 5px;">{{ icon }}</mat-icon>
		<span>{{ text }}</span>
	</span>
</ng-template>

<ng-template #cancelInviteTemplate let-icon="icon" let-text="text" let-inviteGUID="inviteGUID">
	<span class="alignRow" (click)="cancelInvite(inviteGUID)">
		<mat-icon style="margin-right: 5px;">{{ icon }}</mat-icon>
		<span>{{ text }}</span></span>
</ng-template>

<ng-template #disabledIcon let-icon="icon" let-text="text">
	<span class="alignRow">
		<mat-icon class="app-icon app--icon-disabled">{{ icon }}</mat-icon>
		<span>{{ text }}</span>
	</span>
</ng-template>

<ng-template #deletedUsers>
	<div class="deletedUsers gridRow" style="font-weight: bolder;">
		<span>User</span>
		<span>Email</span>
		<span>Date Removed</span>
		<span>Removed By</span>
	</div>
	<div class="deletedUsers gridRow" *ngFor="let user of deletedAccountUsers">
		<span>{{user.Name}}</span>
		<span>{{user.Email}}</span>
		<span>{{convertEpoch(user.DateDeleted ?? 0)}}</span>
		<span>{{user.DeletedBy}}</span>
		<span class="gridDeletedUser-Hover">
			<mat-icon class="deletedUserButton" title="Recover {{user.Name}}"
				(click)="recoverUser(user)">person_add</mat-icon>
		</span>
	</div>
</ng-template>